const systemList = [
  {
    path: 'expressLogisticsCompanyList',
    name: 'expressLogisticsCompanyList',
    meta: { title: '快递物流公司清单' },
    component: () => import('@/views/system/systemSet/expressLogisticsCompanyList')
  },
  {
    path: 'documentTemplateManage',
    name: 'documentTemplateManage',
    meta: { title: '文件模板管理' },
    component: () => import('@/views/system/systemSet/documentTemplateManage')
  },
  {

    path: 'fundOccupation',
    name: 'fundOccupation',
    meta: { title: '资金占用比例' },
    component: () => import('@/views/system/systemSet/fundOccupation')
  },
  {
    path: 'futuresDeliveryTimeSet',
    name: 'futuresDeliveryTimeSet',
    meta: { title: '期货货期设置' },
    component: () => import('@/views/system/systemSet/futuresDeliveryTimeSet')
  },
  {
    path: 'companyBankAccountSet',
    name: 'companyBankAccountSet',
    meta: { title: '企业银行账号配置' },
    component: () => import('@/views/system/systemSet/companyBankAccountSet')
  },
  {
    path: 'systemForfeitureScaleSet',
    name: 'systemForfeitureScaleSet',
    meta: { title: '系统罚没比例设置' },
    component: () => import('@/views/system/systemSet/systemForfeitureScaleSet')
  },
  {
    path: 'otherBillTaxRateSet',
    name: 'otherBillTaxRateSet',
    meta: { title: '其他票据税率设置' },
    component: () => import('@/views/system/systemSet/otherBillTaxRateSet')
  },
  {
    path: 'processManagement',
    name: 'processManagement',
    meta: { title: '流程管理' },
    // redirect: '/system/systemSet/processManagement/orderstockflow',
    component: () => import('@/views/system/systemSet/processManagement'),
    children: [
      {
        path: 'specialofferflow',
        name: 'specialofferflow',
        meta: { title: '客户特价申请表' },
        component: () => import('@/views/system/flow/copmponents/sales/specialofferflow')
      }, {
        path: 'sellpactflow',
        name: 'sellpactflow',
        meta: { title: '销售合同流程' },
        component: () => import('@/views/system/flow/copmponents/sales/sellpactflow')
      },
      {
        path: 'orderstockflow',
        name: 'orderstockflow',
        meta: { title: '订单备货流程' },
        component: () => import('@/views/system/flow/copmponents/sales/orderstockflow')
      },
      {
        path: 'deliverflow',
        name: 'deliverflow',
        meta: { title: '发货申请表' },
        component: () => import('@/views/system/flow/copmponents/sales/deliverflow')
      },
      {
        path: 'releaseitoryflow',
        name: 'releaseitoryflow',
        meta: { title: '释放库存流程' },
        component: () => import('@/views/system/flow/copmponents/sales/releaseitoryflow')
      },
      {
        path: 'lackexflow',
        name: 'lackexflow',
        meta: { title: '报缺流程' },
        component: () => import('@/views/system/flow/copmponents/sales/lackexflow')
      },
      {
        path: 'baddebtflow',
        name: 'baddebtflow',
        meta: { title: '坏账流程' },
        component: () => import('@/views/system/flow/copmponents/sales/baddebtflow')
      },
      {
        path: 'sellticketflow',
        name: 'sellticketflow',
        meta: { title: '开票流程' },
        component: () => import('@/views/system/flow/copmponents/sales/sellticketflow')
      },
      {
        path: 'popayflow',
        name: 'popayflow',
        meta: { title: '采购付款流程' },
        component: () => import('@/views/system/flow/copmponents/sales/popayflow')
      },
      {
        path: 'lackflow',
        name: 'lackflow',
        meta: { title: '采购报缺流程' },
        component: () => import('@/views/system/flow/copmponents/sales/lackflow')
      },
      {
        path: 'customerdepositflow',
        name: 'customerdepositflow',
        meta: { title: '客户提现流程' },
        component: () => import('@/views/system/flow/copmponents/sales/customerdepositflow')
      },
      {
        path: 'customershiftflow',
        name: 'customershiftflow',
        meta: { title: '客户关系转移流程' },
        component: () => import('@/views/system/flow/copmponents/sales/customershiftflow')
      },
      {
        path: 'starleveladjustflow',
        name: 'starleveladjustflow',
        meta: { title: '客户关系转移流程' },
        component: () => import('@/views/system/flow/copmponents/sales/starleveladjustflow')
      },
      {
        path: 'creditleveladjustflow',
        name: 'creditleveladjustflow',
        meta: { title: '信用调整流程' },
        component: () => import('@/views/system/flow/copmponents/sales/creditleveladjustflow')
      },
      {
        path: 'baliorflow',
        name: 'baliorflow',
        meta: { title: '修改&取消委托人流程' },
        component: () => import('@/views/system/flow/copmponents/sales/baliorflow')
      },
      {
        path: 'supplieraccountadjustflow',
        name: 'supplieraccountadjustflow',
        meta: { title: '供应商余额调整流程' },
        component: () => import('@/views/system/flow/copmponents/sales/supplieraccountadjustflow')
      },
      {
        path: 'sendproflow',
        name: 'sendproflow',
        meta: { title: '发货流程' },
        component: () => import('@/views/system/flow/copmponents/sales/sendproflow')
      },
      {
        path: 'supplierrechargeflow',
        name: 'supplierrechargeflow',
        meta: { title: '供应商充值流程' },
        component: () => import('@/views/system/flow/copmponents/sales/supplierrechargeflow')
      },
      {
        path: 'popactflow',
        name: 'popactflow',
        meta: { title: '采购合同审批' },
        component: () => import('@/views/system/flow/copmponents/sales/popactflow')
      },
      {
        path: 'customerbalanadjustflow',
        name: 'customerbalanadjustflow',
        meta: { title: '采购合同审批' },
        component: () => import('@/views/system/flow/copmponents/sales/customerbalanadjustflow')
      },
      {
        path: 'supplieractivity',
        name: 'supplieractivity',
        meta: { title: '供应商活动收款流程' },
        component: () => import('@/views/system/flow/copmponents/sales/supplieractivityflow')
      },
      {
        path: 'salesreturnsflow',
        name: 'salesreturnsflow',
        meta: { title: '销售退货流程' },
        component: () => import('@/views/system/flow/copmponents/sales/salesreturnsflow')
      },
      {
        path: 'salesreturnscontractflow',
        name: 'salesreturnscontractflow',
        meta: { title: '销售退货合同流程' },
        component: () => import('@/views/system/flow/copmponents/sales/salesreturnscontractflow')
      },
      {
        path: 'poreturnsflow',
        name: 'poreturnsflow',
        meta: { title: '采购退货流程' },
        component: () => import('@/views/system/flow/copmponents/sales/poreturnsflow')
      },
      {
        path: 'poreturnscontractflow',
        name: 'poreturnscontractflow',
        meta: { title: '采购退货合同流程' },
        component: () => import('@/views/system/flow/copmponents/sales/poreturnscontractflow')
      },
      {
        path: 'poreturnscpriceflow',
        name: 'poreturnscpriceflow',
        meta: { title: '采购退货收款流程' },
        component: () => import('@/views/system/flow/copmponents/sales/poreturnscpriceflow')
      }
    ]
  },
  {
    path: 'bankFormHeaderMap',
    name: 'bankFormHeaderMap',
    meta: { title: '银行表单表头映射' },
    component: () => import('@/views/system/systemSet/bankFormHeaderMap')
  },
  {
    path: 'companyFrameworkSet',
    name: 'companyFrameworkSet',
    meta: { title: '企业架构配置' },
    component: () => import('@/views/system/systemSet/companyFrameworkSet')
  },
  {
    path: 'companyInformation',
    name: 'companyInformation',
    meta: { title: '公司信息' },
    component: () => import('@/views/system/systemSet/companyInformation')
  },
  {
    path: 'commissionPercentageSet',
    name: 'commissionPercentageSet',
    meta: { title: '提成比例设置' },
    component: () => import('@/views/system/systemSet/commissionPercentageSet')
  },
  {
    path: 'accountManagement',
    name: 'accountManagement',
    meta: { title: '账号管理' },
    component: () => import('@/views/system/systemSet/accountManagement')
  },
  {
    path: 'roleManagement',
    name: 'roleManagement',
    meta: { title: '角色权限管理' },
    component: () => import('@/views/system/systemSet/roleManagement')
  }, {
    path: 'brand',
    name: 'brand',
    meta: {
      title: '品牌管理'
    },
    component: () => import('@/views/system/systemSet/brand')
  }
]

export default systemList
